import { Grid, Typography } from "@mui/material";

import { DisplayCurrency } from "src/components";


interface InvoiceStatProps {
    label: string;
    icon?: JSX.Element;
    value: number;
}

const InvoiceStat = ({ label, icon, value }: InvoiceStatProps) => {
    return (
        <Grid>
            <Grid
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    placeItems: 'center',
                    padding: '4px',
                    flexDirection: 'row',
                }}
                gap={1}
            >
                <Typography data-testid="invoice-stat-label" sx={{ fontSize: '16px', fontWeight: 400, color: '#666' }}>
                    {label}
                </Typography>
            </Grid>
            <Grid
                sx={{
                    display: 'flex',
                    padding: '8px',
                    flexDirection: 'row',
                }}
                alignItems="center"
                gap={1}
            >
                {(() => {
                    if (icon) {
                        return (
                            <>
                                {icon}
                                <Typography fontWeight={500} data-testid="invoice-stat-icon" sx={{ fontSize: '24px', color: '#575757' }}>{value}</Typography>
                            </>
                        );
                    }
                    return (
                        <DisplayCurrency
                            centsAmount={value}
                            localeLanguage={navigator.language}
                            style={{ fontSize: '24px', fontWeight: 500, color: '#575757' }}
                        />
                    );
                })()}
            </Grid>
        </Grid>
    );
};
export default InvoiceStat;
